import { Box, Typography } from "@mui/material";
import globalStyles from "../../global";
import { getResponsiveSize } from "../../utils/responsive";
import { flexCenter } from "../../utils/styles";

const GetInTouch = () => {
  return (
    <Box sx={styles.mainbox}>
      <Box sx={styles.mainContainer}>
        <Typography
          sx={{
            fontFamily: "AllRoundGothicBold",
            fontWeight: 400,
            lineHeight: "65px",
            letterSpacing: "1%",
            fontSize: { md: "45px", sm: "30px", xs: "26px" },
            color: globalStyles?.colors.army_green,
            mb: 1,
          }}
        >
          GET IN TOUCH
        </Typography>
        <Typography
          sx={{
            fontFamily: "'Poppins'",
            fontWeight: 400,
            fontSize: { sm: "18px", xs: "14px" },
            lineHeight: "auto",
            letterSpacing: "1%",
            textAlign: "center",
            color: "#666666",
            mb: 4,
          }}
        >
          Have Questions Or Ideas? We're Just An Email waay! Let's Connect And
          Make Things Happen.
        </Typography>
      </Box>
      <Box
        sx={{
          ...styles.cardsWrapper,
          maxWidth: "1200px",
          mx: "auto",
          width: "100%",
          px: 2,
        }}
      >
        <Box sx={styles.cardsGrid}>
          <Box sx={styles.card}>
            <Box sx={styles.cardTitle}>Collaborations</Box>
            <Box sx={styles.cardText}>
              Let's explore exciting opportunities to work together and make an
              impact!
            </Box>
            <Box
              component="a"
              href="mailto:franchise@uclean.in"
              sx={styles.emailLink}
            >
              collab@ucleaninternational.com
            </Box>
          </Box>

          <Box sx={styles.card}>
            <Box sx={styles.cardTitle}>Marketing</Box>
            <Box sx={styles.cardText}>
              Ready to grow and amplify your message? Let's create something
              impactful!
            </Box>
            <Box
              component="a"
              href="mailto:global@uclean.in"
              sx={styles.emailLink}
            >
              marketing@ucleaninternational.com
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  mainbox: {
    backgroundColor: "#F2F3F0",
    textAlign: "center",
    // height: getResponsiveHeight(548),
    pb: 12,
    pt: 8,
  },
  mainContainer: {
    backgroundColor: "#F2F3F0",
    width: "100%",
  },
  heading: {
    paddingTop: getResponsiveSize(10),
    color: globalStyles.colors.army_green,
    fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    lineHeight: 1.2,
    textAlign: "center",
    "@media (max-width:600px)": {
      fontSize: getResponsiveSize(32),
    },
  },
  subheading: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    color: globalStyles.colors.black,
    textAlign: "center",
    padding: getResponsiveSize(5),
    "@media (max-width:600px)": {
      fontSize: getResponsiveSize(16),
    },
  },
  cardsContainer: {
    backgroundColor: globalStyles.colors.white,
    width: "100%",
  },
  cardsWrapper: {
    margin: "auto",
  },
  cardsGrid: {
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(1, 1fr)",
      sm: "repeat(1, 1fr)",
      md: "repeat(2, 1fr)",
      lg: "repeat(2, 1fr)",
    },
    gap: 3,
  },
  card: {
    ...flexCenter,
    flexDirection: "column",
    backgroundColor: globalStyles.colors.white,
    borderRadius: getResponsiveSize(8),
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    py: 4,
    px: {
      sm: 6,
      xs: 2,
    },
  },
  cardTitle: {
    marginBottom: getResponsiveSize(3),

    color: globalStyles.colors.army_green,
    fontWeight: 600,
    fontSize: { md: "28px", sm: "24px", xs: "20px" },
    lineHeight: "auto",
    letterSpacing: "2%",
    textAlign: "justify",
  },
  cardText: {
    color: "#4D4D4D",
    marginBottom: 2,
    fontSize: { sm: "16px", xs: "12px" },
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    lineHeight: "auto",
    letterSpacing: "0%",
  },
  emailLink: {
    color: "#65BA0D",
    textDecoration: "none",
    fontSize: { sm: "16px", xs: "12px" },
    lineHeight: "auto",
    letterSpacing: "0%",
    fontFamily: ' "Poppins", serif ',
    fontWeight: 600,
    // marginBottom: getResponsiveSize(2),
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

export default GetInTouch;
